module.exports = __webpack_public_path__ + "img/ic-engage.d72d39e.svg";